import { render, staticRenderFns } from "./modal-offer-halloween-1.vue?vue&type=template&id=53105384"
import script from "./modal-offer-halloween-1.vue?vue&type=script&lang=js"
export * from "./modal-offer-halloween-1.vue?vue&type=script&lang=js"
import style0 from "./modal-offer-halloween-1.vue?vue&type=style&index=0&id=53105384&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports